import React from 'react';
import { useSelector } from 'react-redux';

import { SupportButton } from './SupportButton';
import { Paragraph, Title } from '../../components/Text';
import { Flex } from '../../components/Flex';
import { Modal } from 'antd';

const issueNotification = ({
    centered: true,
    icon: null,
    className: 'sp-confirm-modal',
    title: <Title h4 color="#E8AF1D">Important Information</Title>,
    okText: "Ok",
    okButtonProps: { style: { background: "var(--sp-main-color)", borderRadius: "4px", border: "none", fontWeight: "600" } },
    onCancel() { },
    content: <Flex direction="column" gap={{ bottom: 6 }}>
        <Paragraph>We value you as a customer.</Paragraph>
        <Paragraph>However, this feature is currently unavailable. While we work on a new customer experience for you, please contact SP Support via email at <a href="mailto: spsupport@vmssoftware.com">spsupport@vmssoftware.com</a>.</Paragraph>
        <Paragraph>Please provide the following information:</Paragraph>
        <Paragraph>
            <ul>
                <li>VSI VON (Support contract number)</li>
                <li>Company Name, if applicable</li>
                <li>Contact Name</li>
                <li>Contact Preferred Phone Number</li>
                <li>Contact Preferred Email Address</li>
                <li>Product with Issue</li>
                <li>Problem Statement</li>
            </ul>
        </Paragraph>
        <Paragraph>Also, please attach a copy of VSI$SUPPORT in the email.  If you do not have VSI$SUPPORT, you may obtain it <a href="https://products.vmssoftware.com/vsisupport" target="_blank">here</a>.</Paragraph>
    </Flex>
});

const SupportButtonContainer = (props) => {
    const { email } = useSelector(state => state.user.grants);

    const handleMenuClick = (key) => {
        if (key == 1) {
            Modal.info({ ...issueNotification });
        }
    };

    return(
        email
            ? <SupportButton
                handleMenuClick={handleMenuClick}
            />
            : null
        )
};

export { SupportButtonContainer };
